<template>
  <div class="success-wrapper">
    <div class="success-icon">
      <i class="sr sr-check"></i>
    </div>
    <h3 class="success-title">{{ title || $t('sign_dialog.title') }}</h3>
    <p class="success-desc">{{ description || $t('sign_dialog.description') }}</p>
    <WarningInfo :body="$t('contract.trade_settlement_rights')"/>
    <ic-button size="tn" block class="done-btn" @click="$emit('done')">
      {{ buttonText || $t('common.close') }}
    </ic-button>
  </div>
</template>

<script>
import WarningInfo from "../WarningInfo.vue";

export default {
  components: { WarningInfo },
  name: "SuccessMessage",
  props: {
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    buttonText: { type: String, default: '' },
  },
  emits: ["done"]
}
</script>

<style scoped lang="scss">
.success-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 32px 32px;
  text-align: center;
  background-color: white;
  border-radius: 20px;
  min-width: 380px;
  max-width: 480px;
}

.success-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #e8f5ee;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;

  i {
    font-size: 38px;
    color: #2EBD85;
  }
}

.success-title {
  font-size: 22px;
  font-weight: 700;
  color: var(--text-primary-color);
  margin-bottom: 10px;
}

.success-desc {
  font-size: 14px;
  color: #939393;
  margin-bottom: 20px;
  line-height: 1.6;
}

.done-btn {
  background: #0C293A !important;
  margin-top: 20px;
  border-radius: 12px;
}
</style>
